import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { useMyContext } from "../MyContext";
import { fetchSecure } from "../utils/utils";
import { Spinner } from "react-bootstrap"; // Import Spinner for loading state
import SuperAppButton from "./SuperAppButton"; // Import for refresh button
import "../pages/Home.css";

//Components

function ShowAgent(props) {
  const [agentURL, setAgentURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const myContext = useMyContext();

  // Function to validate agentURL
  const isValidAgentURL = (url, baseURL) => {
    const urlPattern = /^https:\/\/.*\/chat\/WWWW\/.+/;
    const appDomain = window.location.origin;
    return (
      urlPattern.test(url) &&
      !url.startsWith(appDomain) &&
      baseURL && // Ensure baseURL is defined
      baseURL.trim() !== "" // Ensure baseURL is not empty
    );
  };

  // Function to refresh URL
  const refresh = () => {
    setError(null);
    setLoading(true);
    loadConfig();
  };

  async function loadConfig() {
    try {
      // Check if base URL is available
      const baseURL =
        props.consoleAgent && myContext["data"]["agentXLURL"]
          ? myContext["data"]["agentXLURL"]
          : myContext["data"]["agentURL"];

      if (!baseURL || baseURL.trim() === "") {
        throw new Error("Chatbot URL is not configured.");
      }

      const tokenResponse = await fetchSecure("/api/getToken");
      if (!tokenResponse.ok) {
        throw new Error("Failed to fetch token");
      }
      const token = await tokenResponse.json();

      const constructedURL = `${baseURL}/chat/WWWW/${props.agent_id}/${token["accessToken"]}`;

      // Validate the constructed URL
      if (!isValidAgentURL(constructedURL, baseURL)) {
        console.error("Invalid agentURL:", constructedURL);
        throw new Error("Invalid chatbot URL.");
      }

      // Log for debugging
      //console.log("Constructed agentURL:", constructedURL);
      //console.log("Context Data:", myContext.data);
      //console.log("Props:", props);

      setAgentURL(constructedURL);
      setError(null);
    } catch (error) {
      console.error("Error in loadConfig:", error.message);
      setError("Failed to load chatbot. Please try again.");
      setAgentURL("");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setLoading(true);
    loadConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.agent_id,
    props.refreshKey,
  ]); /* KAD changed this on Feb 8, 2025 so the iframe would change when the agent_id property changed */

  return (
    <div style={{ textAlign: "center" }}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "90dvh",
          }}
        >
          <Spinner animation="border" size="sm" style={{ color: "white" }} />
        </div>
      ) : error ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "90dvh",
          }}
        >
          <p
            style={{ color: "red", marginBottom: "10px", padding: 10 }}
          >{`Something went wrong. Please Retry`}</p>
          <SuperAppButton
            className="primary-gradient-btn"
            onClick={refresh}
            style={{ padding: "4px 16px", fontSize: "14px" }}
          >
            Retry
          </SuperAppButton>
        </div>
      ) : (
        <iframe
          title={agentURL}
          src={agentURL}
          className="myIframe"
          height="620"
          scrolling="no"
        />
      )}
    </div>
  );
}

export default withRouter(ShowAgent);
